import React from 'react'
import Helmet from 'react-helmet'

const Contact = () =>
  <div>

    <Helmet
      title='Contact | Cory Schadt'
      bodyAttributes={{
        class: 'inner'
      }}
    />

    <div className='page fade'>
      <div className='container'>
        <div className='content'>
          <h1>Contact</h1>
          <div className='text'>
            <p>Email: <a href='mailto:coryschadt@gmail.com'>coryschadt@gmail.com</a></p>
          </div>
        </div>
      </div>
    </div>
  </div>
export default Contact



// WEBPACK FOOTER //
// ./src/pages/contact.js